import { Component, Input, ViewChild, NgZone, OnInit,EventEmitter,Output } from '@angular/core';
import { AgmMap } from '@agm/core';


declare var $: any;




@Component({
  selector: 'slides-component',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.scss']
})
export class SlidesComponent implements OnInit {
  geocoder:any;
  @Input('sliderHtml') sliderHtml;
  @Input('mapa') mapa;

  
  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() filter: EventEmitter<any> = new EventEmitter();


  // public latitude = 13.802755;
  // public longitude = -88.903222;
  public latitude = 13.699991;
  public longitude = -89.226777;
  public mapType = 'roadmap'; //HYBRID, satellite, roadmap, terrain
  public iconCorresponsal = { url: 'assets/img/iconos/pin-corresponsal.png'/*, scaledSize: {height: 53, width: 42}*/ };
  public iconCajero = { url: 'assets/img/iconos/pin-cajero.png',/* scaledSize: {height: 28, width: 17} */};
  public iconAgencia = { url: 'assets/img/iconos/pin-agencia.png'/*, scaledSize: {height: 63, width: 52}*/ };
  public filtroVisible = false;
  public zoom = 10;
  public resolucion;
  public Responsive:boolean = false;  
  public varTest=true;

  public formularioParaFiltrar = {
    mode: '0',
    departamento: '0',
    texto: ''
  };

  constructor() {
    
  }

  ngOnInit() {
    // console.log(this.sliderHtml);
    // console.log("idiomaEspañol - slides--->"+localStorage.getItem("idiomaEspañol"));
    this.functionsjs();
   
    this.navResponsive();
    
    
  }

  redireccionarAPaginaExistente(uuid) {
    this.uuid.emit(uuid);
  }


public navResponsive(){
    if(screen.width < 600){
      this.Responsive = true;
    }
    else{
      this.Responsive = false;
    }
  }

  

  functionsjs() {
    $('body').on('click', '#filter-map-search, .close', () => {
      var $e = $('.bg-image div.filtros div.wrap div.form .wrapper-results');

      if (!$e.hasClass('active')) {
        $e.addClass('active');

        $.fn.fullpage.setAllowScrolling(false);
        $.fn.fullpage.setKeyboardScrolling(false);
      } else {
        $e.removeClass('active');

        $.fn.fullpage.setAllowScrolling(true);
        $.fn.fullpage.setKeyboardScrolling(true);
      }
    });
  }

  cargarLatitudYLongitudPredefinida() {
    this.zoom = 14;
    this.latitude = 13.699991;
    this.longitude = -89.226777;
  }

  verFiltros() {
    this.cargarLatitudYLongitudPredefinida();
    this.filtroVisible = true;

  }

  otroMetodo() {
    console.log("otroMetodo()");
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.zoom = 14;
          this.latitude =position.coords.latitude;
          this.longitude = position.coords.longitude;
        },
        error => {
          this.cargarLatitudYLongitudPredefinida();
        }, { enableHighAccuracy: true });
    }else{
      this.cargarLatitudYLongitudPredefinida();
    }
  }

  public filtar() {

if (this.formularioParaFiltrar.mode != '0') {
this.cargarLatitudYLongitudPredefinida();

    let filtro: any = {};
    let departamento: string;
    let mode: string;
    let texto: string;

    if (this.formularioParaFiltrar.departamento != '0') {
      departamento = this.formularioParaFiltrar.departamento;
      filtro.departamento = departamento;
    }

    if (this.formularioParaFiltrar.texto != '') {
      texto = this.formularioParaFiltrar.texto;
      filtro.texto = texto;
    }
    
    mode = this.formularioParaFiltrar.mode;
    filtro.mode = mode;


    //console.warn(filtro);
    this.filter.emit(filtro);
    
}
    
  }



  public irALocalidad(localidad) {
    // console.warn("Ir a localidad " ,localidad);
    this.latitude = parseFloat(localidad.latitud);
    this.longitude = parseFloat(localidad.longitud);
    this.zoom = 18;
    this.filtroVisible = false;
  }


   onDomChange($event: Event): void {
    // console.log( "evento Dom Change--->"+$event);
   }

 


  /*
   functionsjs(){
    let e=`
    $('body').on('click', 'div.close', () => {
      var $e = $('.wrapper-results');

      if (!$e.hasClass('active')) {
        $e.addClass('active');

        $.fn.fullpage.setAllowScrolling(false);
        $.fn.fullpage.setKeyboardScrolling(false);
      } else {
        $e.removeClass('active');

        $.fn.fullpage.setAllowScrolling(true);
        $.fn.fullpage.setKeyboardScrolling(true);
      }
    });
    `;

    $('#test-c').append(`<script>${e}</script>`);
  }
  */

/*
  functionsjs2() {
    $('body').on('click', '#filter-map-search, .close', () => {
     var $e = $('.bg-image div.filtros div.wrap div.form .wrapper-results');

      if (!$e.hasClass('active')) {
        $e.addClass('active');

        $.fn.fullpage.setAllowScrolling(false);
        $.fn.fullpage.setKeyboardScrolling(false);
      } else {
        $e.removeClass('active');

        $.fn.fullpage.setAllowScrolling(true);
        $.fn.fullpage.setKeyboardScrolling(true);
      }
    });
  }
    */






functionsjs2() {
setTimeout(function () {
                if ($.fn.fullpage.destroy) {
                  $.fn.fullpage.destroy('all');
                  // console.warn("$.fn.fullpage.destroy");
                }

                setTimeout(function () {
                  $('#fullpage').fullpage({
                    // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                    menu: '#myMenu',
                    scrollingSpeed: 1000,
                    autoScrolling: true,
                    scrollOverflow: false,
                    resize: false,
                    
                    keyboardScrolling: false,
                    afterRender: function () {
                      var $map = document.getElementById('inner-map');
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-1');

                      $items.removeClass('custom-class-active');
                      $next.addClass('example custom-class-active');
                    },
                    onLeave: function(index, nextIndex, direction) {
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-'+nextIndex);

                      $items.removeClass('custom-class-active');
                      $next.addClass('custom-class-active');
                    }
                  });
                }, 100);
              }, 75);

}
  readLocalStorageValue(key) {
    // console.log("local storage slides----->" +  localStorage.getItem(key));
    //this.functionsjs2();
    return localStorage.getItem(key);
}

}
